import { Discount } from '../api/discountAPI';

export const discountMock: Discount = {
    discountCode: 'SKITURerBEST',
    codeIsValid: true,
    discountedPrice: 500,
};
